// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__11oXs","loaderOuter":"PageOverlayLoader_loaderOuter__1NbZD"};